var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0425 10.2216C8.25662 10.436 8.54712 10.5566 8.85012 10.5569L9.42917 10.5569C9.73151 10.5534 10.0208 10.4333 10.2368 10.2216L18.0539 2.38927C18.1982 2.24621 18.2793 2.05147 18.2793 1.84831C18.2793 1.64516 18.1982 1.45042 18.0539 1.30736L16.972 0.225455C16.8316 0.0821199 16.6394 0.00134652 16.4387 0.00134651C16.238 0.0013465 16.0458 0.0821198 15.9054 0.225455L9.13964 7.00641L2.37393 0.225455C2.23087 0.0812171 2.03613 8.51207e-05 1.83298 8.51118e-05C1.62982 8.51029e-05 1.43508 0.081217 1.29202 0.225455L0.225356 1.30736C0.081118 1.45042 -1.29619e-05 1.64516 -1.29708e-05 1.84831C-1.29797e-05 2.05146 0.081118 2.2462 0.225356 2.38926L8.0425 10.2216Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.12ace8b78163cedd1e091684c8b11f98.svg";
export { ForwardRef as ReactComponent };